import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import { css } from "@emotion/react"

export default () => (
  <StaticQuery
    query={graphql`
      query consultationEnQuery {
        file(
          relativePath: {
            eq: "consultation-chirurgie-main-epaule-coude-paris-7.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => (
      <Img
        fluid={data.file.childImageSharp.fluid}
        alt="Hand, shoulder and elbow surgery consultation in Paris 7th arrondissement"
        css={css`
          width: 100%;
          transform: translateY(85px);
          z-index: -1;
          margin-top: -85px;
          @media (max-width: 1024px) {
            transform: none;
            margin-top: 0;
            border-radius: 7px 7px 0 0;
          }
        `}
      />
    )}
  />
)
